import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { PowContext } from "./PowWrapper";
import { ProgressIndicatorProps } from "../models/Types";

export default function ProgressIndicator(props: ProgressIndicatorProps) {
  const { answers, challenges } = useContext(PowContext);
  const { t } = useTranslation();

  const nAnswers = answers.length;
  const nTotalChallenges = challenges.length;
  const nRemainingChallenges =
    nTotalChallenges - props.nAnswersSolvedInBackground;
  const nRemainingAnswers = nAnswers - props.nAnswersSolvedInBackground;
  const progressRatio =
    (nRemainingChallenges && nRemainingAnswers / nRemainingChallenges) || 0;
  const safeProgressRatio = Math.max(progressRatio, 0); // if buggy, at least don't display negative numbers
  const progressDisplayedPercentage = Math.round(safeProgressRatio * 100);

  return (
    <div className="progressIndicatorContainer">
      <div className="relative">
        <p className="small-text">
          {t("SolvingChallenges.text")}
          <span className="pull-right">{progressDisplayedPercentage}%</span>
        </p>
        <progress className="progress" value={safeProgressRatio} />
      </div>
    </div>
  );
}
